import { rest } from 'msw';
import { getDelayVal, mswBaseUri } from 'mocks/utils/utils';
import { mockGroupLandingData } from 'mocks/store/insights/groupsLanding';

export const insightsGroupsHandlers = [
  rest.get(mswBaseUri('v1/groups/landing'), (req, res, ctx) => res(ctx.delay(getDelayVal(50)), ctx.status(200), ctx.json(mockGroupLandingData))),
];

export default insightsGroupsHandlers;
